<template>
    <div>
      <div class='fourlist'>
        <div style="borderRight:1px solid #d8d8d8;font-size: 18px">{{$lang.klzh}}</div>
        <div v-for='(v,i) in islang=="big5"?list:en_list' :key='i+"101"' :style="{borderRight:(i+1)<list.length?'1px solid #d8d8d8':''}" @click='handclick(i)'>
        <span :style="{borderBottom:isright==i?'3px solid #09666E':''}">{{v}}</span>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['isnum'],
    data(){
      return{
        islang : window.localStorage.guanwanglang,
        list:[this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh],
        en_list:[this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh],
        // list:[this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh,this.$lang.wskh],
        // en_list:[this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh,this.$lang.wskh],
        urllist:['/apply_in_person_individual','/sent_by_post_individual','/account_opening_appointment','/account_opening_online','https://hk.qmisit.com/accopen/?lang='],
        isright:0
      }
    },
    watch:{
      isnum:{
        immediate:true,
        handler(ev){
          this.isright = this.isnum
        }
      }
    },
    methods:{
      postdata(){
        this.$ajax({
          method:'post',
          url:this.$api.yuyuekaihu
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      handclick(i){
        if(i==4){
          window.open(this.urllist[i]+this.islang)
        }else
          // if(i==2){
          //   this.postdata()
          //   window.open(this.urllist[i]+this.islang)
          // }else 
          if(i==2){
            this.isright = 2;
            this.$router.push(this.urllist[2])
          }else 
          if(this.urllist[i]){
            this.isright = i
            this.$router.push(this.urllist[i])
          }
      }
    }
  }
</script>

<style scoped>
  .fourlist{
    /* display: flex;
    justify-content: space-between; */
    margin-bottom: 2.5rem;
    margin-left: -1rem;
  }
  .fourlist div{
    display: inline-block;
    padding: 0 1rem;
    font-size: 16px;
    color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/assetmanage/fourlist.vue